import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalHome.css";
import { FiFileText, FiShield, FiCpu, FiLock, FiCheckCircle } from "react-icons/fi";
import { color } from "framer-motion";

export default function LegalHome() {
    const navigate = useNavigate(); // For navigation

    const today = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    const legalPages = [
        { title: "Terms of Service", desc: "Our terms outline the rules, guidelines, and agreements for using the BodhAI platform. Please read carefully before proceeding.", id: "BAILCP-V-TOS-2.2", updated: "December 5, 2025", icon: <FiFileText />, link: "/legal/terms" },
        { title: "Privacy Policy", desc: "Learn how we collect, use, store, and protect your personal information. Your privacy matters to us.", id: "BAILCP-V-PP-2.2", updated: "December 8, 2025", icon: <FiShield />, link: "/legal/privacy" },
        { title: "Cookie Policy", desc: "Understand how we use cookies and similar technologies to enhance your browsing experience on our platform.", id: "BAILCP-V-CP-2.2", updated: "December 3, 2025", icon: <FiCpu />, link: "/legal/cookies" },
        { title: "Security", desc: "Discover the measures we take to protect your data and ensure a secure experience on BodhAI platform.", id: "BAILCP-V-SEC-2.2", updated: "December 10, 2025", icon: <FiLock />, link: "/legal/security" },
        { title: "Compliance", desc: "Review our compliance with industry standards, regulations, and best practices for data protection.", id: "BAILCP-V-COM-2.2", updated: "December 7, 2025", icon: <FiCheckCircle />, link: "/legal/compliance" },
    ];

    return (
        <div className="legal-home-container">
            {/* Top bar */}
            <div className="legal-topbar">
                <div className="legal-version">
                    Legal Center <span className="legal-version-badge">v2.2</span>
                </div>
                <div className="legal-dates">
                    Today: {today} &nbsp; | &nbsp; Last Updated: December 10, 2025
                </div>
            </div>

            {/* Header */}
            <div className="legal-header">
                <h1>BodhAI <span className="legal-center">Legal Center</span> 
                 <span style={{color:'#848787',fontSize:'25px'}}> v2.2</span>
                 <span className="blink-dot"></span></h1>
                <p>Everything about rights, safety, privacy & platform rules — in one place.</p>
            </div>

            {/* Cards Grid */}
            <div className="legal-cards-grid">
                {legalPages.map((page) => (
                    <div
                        key={page.id}
                        className="legal-card"
                        onClick={() => navigate(page.link)}
                    >
                        <div className="card-icon">{page.icon}</div>
                        <h2>{page.title}</h2>
                        <p>{page.desc}</p>
                        <div className="card-meta">
                            <div className="meta-row">
                                <span>Legal ID:</span>
                                <span className="legal-id-value">{page.id}</span>
                            </div>

                            <div className="meta-row">
                                <span>Last Updated:</span>
                                <span className="updated-value">{page.updated}</span>
                            </div>
                        </div>

                        <br/><br/>
                        <div className="read-more">Read More →</div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="legal-footer">
                Have questions? Contact our legal team at <a href="mailto:legal@bodhai.com">legal@bodhai.com</a>
            </div>
        </div>
    );
}
